import Cookies from "js-cookie";
import { useContext } from "react";
import {
  AVC_BIO_CONFIG,
  AVC_AAA_CONFIG,
  AVC_ObjectFile_CONFIG,
  AVC_PROFILE_CONFIG,
  AVC_SITE_CONFIG,
  AVC_TICKETING_CONFIG,
  AVC_SETTING_CONFIG,
  AVC_BI_CONFIG,
  AVC_WALLET_CREDIT_CONFIG,
  AVC_PERSONNAL_MANAGMENT_CONFIG,
  AVC_NOTIFICATION_CONFIG,
  AVC_LICENSE_CONFIG,
  AVC_PROSRV_CONFIG,
  AVC_ORDERS_MANAGEMENT_CONFIG,
  AVC_ENERGY_MANAGEMENT_CONFIG,
  AVC_AUDITCONTROL_CONFIG,
  AVC_TRANSPORTATION_CONFIG,
  AVC_TRACKING_CONFIG,
  AVC_Orchestrator_CONFIG,
  AVC_FACILITIES_CONFIG,
  AVC_WATER_MANAGEMENT_CONFIG,
  AVC_LABORATORY_CONFIG,
  AVC_EDUCATION_CONFIG,
  AVC_MARKETING_CONFIG,
  AVC_CORRESPONDENCEMANAGEMENT_CONFIG,
  AVC_SERVICE_MANAGEMENT_CONFIG,
  AVC_FEED_CONFIG,
  AVC_AQUACULTURE_MANAGEMENT_CONFIG,
  AVC_PROCESSING_PLANT_CONFIG,
  AVC_COLD_STORAGE_CONFIG,
  AVC_FISHERIES_MANAGEMENT_CONFIG,
  AVC_LOADING_UNLOADING_CONFIG,
  AVC_DISTRIBUTION_CONFIG,
  AVC_IMPORT_EXPORT_CONFIG,
  AVC_ORGANIZATION_CONFIG,
  AVC_WEATHER_MANAGEMENT_CONFIG,
  AVC_SMART_ASSISTANT_CONFIG,
  AVC_PRODUCTION_LINE_CONFIG,
  AVC_WAREHOUSE_CONFIG,
} from "src/config/apollo-client/apolloclient";
import { UserContext } from "src/contexts/UserContext";
import useErrorHandling from "./useErrorHandling";

//clear data
const useRequestConfig = () => {
  const { isLoggedin } = useContext(UserContext);
  const { errorHandling } = useErrorHandling();

  const getTokenWso2 = () => {
    //return process.env.REACT_APP_UIAW_TOKEN
    return "Bearer " + Cookies.get("nmzbxcbashsaoisd");
  };
  //{module,variables,skip,Microservice,onCompleted}
  function requestConfig(config) {
    let uri = null;
    if (config.module === "AVC_BIO") uri = AVC_BIO_CONFIG.AVC_BIO_uri;
    if (config.module === "AVC_TICKET") uri = AVC_TICKETING_CONFIG.AVC_TICKETING_uri;
    if (config.module === "AVC_NOTIFICATION") uri = AVC_NOTIFICATION_CONFIG.AVC_NOTIFICATION_uri;
    if (config.module === "AVC_AAA") uri = AVC_AAA_CONFIG.AVC_AAA_uri;
    if (config.module === "AVC_PROFILE") uri = AVC_PROFILE_CONFIG.AVC_PROFILE_uri;
    if (config.module === "AVC_SETTING") uri = AVC_SETTING_CONFIG.AVC_PROFILE_uri;
    if (config.module === "AVC_EDUCATION") uri = AVC_EDUCATION_CONFIG.AVC_Education_uri;
    if (config.module === "AVC_BI") uri = AVC_BI_CONFIG.AVC_BI_uri;
    if (config.module === "AVC_WALLET_CREDIT") uri = AVC_WALLET_CREDIT_CONFIG.AVC_Wallet_Credit_uri;
    if (config.module === "AVC_CORRESPONDENCE_MANAGEMENT")
      uri = AVC_CORRESPONDENCEMANAGEMENT_CONFIG.AVC_CORRESPONDENCEMANAGEMENT_uri;
    if (config.module === "AVC_PERSONNAL_MANAGMENT") uri = AVC_PERSONNAL_MANAGMENT_CONFIG.AVC_PERSONNAL_MANAGMENT_uri;
    if (config.module === "AVC_SITE") uri = AVC_SITE_CONFIG.AVC_SITE_uri;
    if (config.module === "AVC_LICENSE") uri = AVC_LICENSE_CONFIG.AVC_LICENSE_uri;
    if (config.module === "AVC_MARKETING") uri = AVC_MARKETING_CONFIG.AVC_MARKETING_uri;
    if (config.module === "AVC_PROSRV") uri = AVC_PROSRV_CONFIG.AVC_PROSRV_uri;
    if (config.module === "AVC_ORDERS_MANAGEMENT") uri = AVC_ORDERS_MANAGEMENT_CONFIG.AVC_ORDERS_MANAGEMENT_uri;
    if (config.module === "AVC_TRANSPORTATION") uri = AVC_TRANSPORTATION_CONFIG.AVC_TRANSPORTATION_uri;
    if (config.module === "AVC_LABORATORY") uri = AVC_LABORATORY_CONFIG.AVC_LABORATORY_uri;
    if (config.module === "AVC_TRACKING") uri = AVC_TRACKING_CONFIG.AVC_TRACKING_uri;
    if (config.module === "AVC_FEED") uri = AVC_FEED_CONFIG.AVC_FEED_uri;
    if (config.module === "AVC_WATER_MANAGEMENT") uri = AVC_WATER_MANAGEMENT_CONFIG.AVC_WATER_MANAGEMENT_uri;
    if (config.module === "AVC_ENERGY_MANAGEMENT") uri = AVC_ENERGY_MANAGEMENT_CONFIG.AVC_ENERGY_MANAGEMENT_uri;
    if (config.module === "AVC_FACILITIES") uri = AVC_FACILITIES_CONFIG.AVC_FACILITIES_uri;
    if (config.module === "AVC_AUDITCONTROL") uri = AVC_AUDITCONTROL_CONFIG.AVC_AUDITCONTROL_uri;
    if (config.module === "AVC_AQUACULTURE_MANAGEMENT")
      uri = AVC_AQUACULTURE_MANAGEMENT_CONFIG.AVC_AQUACULTURE_MANAGEMENT_uri;
    if (config.module === "AVC_PROCESSING_PLANT") uri = AVC_PROCESSING_PLANT_CONFIG.AVC_PROCESSING_PLANT_uri;
    if (config.module === "AVC_COLD_STORAGE") uri = AVC_COLD_STORAGE_CONFIG.AVC_COLD_STORAGE_uri;
    if (config.module === "AVC_FISHERIES_MANAGEMENT")
      uri = AVC_FISHERIES_MANAGEMENT_CONFIG.AVC_FISHERIES_MANAGEMENT_uri;
    if (config.module === "AVC_LOADING_UNLOADING") uri = AVC_LOADING_UNLOADING_CONFIG.AVC_LOADING_UNLOADING_uri;
    if (config.module === "AVC_DISTRIBUTION") uri = AVC_DISTRIBUTION_CONFIG.AVC_DISTRIBUTION_uri;
    if (config.module === "AVC_IMPORT_EXPORT") uri = AVC_IMPORT_EXPORT_CONFIG.AVC_IMPORT_EXPORT_uri;
    if (config.module === "AVC_ORGANIZATION") uri = AVC_ORGANIZATION_CONFIG.AVC_ORGANIZATION_uri;
    if (config.module === "AVC_SERVICE") uri = AVC_SERVICE_MANAGEMENT_CONFIG.AVC_SERVICE_MANAGEMENT_uri;
    if (config.module === "AVC_Orchestrator") uri = AVC_Orchestrator_CONFIG.AVC_ORCHESTRATOR_uri;
    if (config.module === "AVC_WEATHER_MANAGEMENT") uri = AVC_WEATHER_MANAGEMENT_CONFIG.AVC_WEATHER_MANAGEMENT_uri;
    if (config.module === "AVC_SMART_ASSISTANT") uri = AVC_SMART_ASSISTANT_CONFIG.AVC_SMART_ASSISTANT_uri;
    if (config.module === "avc_filestorage") uri = AVC_ObjectFile_CONFIG.AVC_ObjectFile_uri;
    if (config.module === "uploadfile") uri = AVC_ObjectFile_CONFIG.AVC_uploadFile_uri;
    if (config.module === "AVC_PRODUCTION_LINE") uri = AVC_PRODUCTION_LINE_CONFIG.AVC_PRODUCTION_LINE_uri;
    if (config.module === "AVC_WAREHOUSE") uri = AVC_WAREHOUSE_CONFIG.AVC_WAREHOUSE_uri;

    let request = {
      fetchPolicy: "network-only",
      skip: config.skip || !isLoggedin,
      context: {
        credentials: "include",
        uri: uri,
        headers: {
          Microservice: config.Microservice,
          AuthorizationWSO2: getTokenWso2(),
        },
      },
      notifyOnNetworkStatusChange: true,
      onCompleted: config.onCompleted,
      onError: config?.onError
        ? config?.onError
        : (error) => {
            if (config?.errorShow !== "OFF") errorHandling(error);
          },
    };
    if (config.Microservice) request.Microservice = config.Microservice;
    if (config.variables) request.variables = config.variables;
    if (config?.hasUpload === true) request.context.hasUpload = true;
    //if (!(config.module ==="AVC_PROSRV" || config.module ==="AVC_TICKET" || config.module ==="AVC_AAA" || config.module ==="AVC_Site" || config.module ==="avc_filestorage" || config.module ==="uploadfile")|| config.module ==="AVC_NOTIFICATION" || config.module==="AVC_ENERGY_MANAGEMENT" || config.module ==="AVC_AUDITCONTROL"|| config.module ==="AVC_FACILITIES"||config.module ==="AVC_WATER_MANAGEMENT")  request.context.headers.Authorization=Cookies.get("Access")

    return request;
  }

  function requestBeforeLoginConfig(config) {
    let uri = null;
    if (config.module === "AVC_AAA") uri = AVC_AAA_CONFIG.AVC_AAA_uri;
    if (config.module === "AVC_PROFILE") uri = AVC_PROFILE_CONFIG.AVC_PROFILE_uri;
    if (config.module === "AVC_SITE") uri = AVC_SITE_CONFIG.AVC_SITE_uri;
    if (config.module === "AVC_TICKET") uri = AVC_TICKETING_CONFIG.AVC_TICKETING_uri;
    if (config.module === "avc_filestorage") uri = AVC_ObjectFile_CONFIG.AVC_ObjectFile_uri;
    if (config.module === "uploadfile") uri = AVC_ObjectFile_CONFIG.AVC_uploadFile_uri;

    let request = {
      fetchPolicy: "network-only",
      skip: config.skip,
      context: {
        credentials: "include",
        uri: uri,
        headers: {
          Microservice: config.Microservice,
          AuthorizationWSO2: getTokenWso2(),
        },
      },
      notifyOnNetworkStatusChange: true,
      onCompleted: config.onCompleted,
      onError: config?.onError
        ? config?.onError
        : (error) => {
            if (config?.errorShow !== "OFF") errorHandling(error);
          },
    };
    if (config.Microservice) request.Microservice = config.Microservice;
    if (config.variables) request.variables = config.variables;
    if (config?.hasUpload === true) request.context.hasUpload = true;
    // if (!( config.module ==="AVC_TICKET" || config.module ==="AVC_AAA" || config.module ==="AVC_Site" || config.module ==="avc_filestorage" || config.module ==="uploadfile"  || config.module === "AVC_MARKETING" ||
    //   config.module === "AVC_CORRESPONDENCE_MANAGEMENT"))  request.context.headers.Authorization=Cookies.get("Access")

    return request;
  }

  return { requestConfig, requestBeforeLoginConfig, getTokenWso2 };
};
export default useRequestConfig;
//end of clear data
